import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import { EmptyState } from '../../components/empty-state/EmptyState';
import { AnimatedLink } from '../../components/animated-link/AnimatedLink';
import { Connect, PropsFromRedux } from './NavFoldersContentContainer';

type Props = PropsFromRedux & {
  foldersStored: boolean;
};

export const RawNavFoldersContent: React.FC<Props> = ({
  foldersStored,
  folders,
}) => {
  return (
    <>
      <ul className="navigation-drop__content">
        {foldersStored && folders.length > 0 && (
          <>
            <span className="navigation-drop__top" />
            {folders.map(folder => (
              <li key={folder.folderKey}>
                <Hyperlink
                  className="navigation-drop__content__item--folder"
                  title={folder.title}
                  href={buildUrlWithParameters(
                    `/dossiers/${folder.folderKey}`,
                    {
                      source: 'folders_dropdown_one',
                    },
                  )}
                >
                  {folder.title}
                </Hyperlink>
              </li>
            ))}{' '}
          </>
        )}
        {(!foldersStored || folders.length > 0) && (
          <div className="navigation-drop__footer">
            <AnimatedLink
              href={buildUrlWithParameters('/dossiers', {
                source: 'folders_dropdown_all',
              })}
            >
              <FormattedMessage id="navigation/folders/NavFoldersContent.tsx/1" />
            </AnimatedLink>
          </div>
        )}
        {foldersStored && folders.length === 0 && (
          <Hyperlink
            href={buildUrlWithParameters('/dossiers', {
              source: 'folders_dropdown_empty',
            })}
          >
            <EmptyState
              title="Aucun dossier"
              logo="/img/logo/empty_state/empty_folder.svg"
            >
              <p>
                <FormattedMessage id="navigation/folders/NavFoldersContent.tsx/2" />
              </p>
            </EmptyState>
          </Hyperlink>
        )}
      </ul>
    </>
  );
};

export const NavFoldersContent = Connect(RawNavFoldersContent);
